(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('OrganoDialogController', OrganoDialogController);

    OrganoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Organo', 'OrganoRelevante','OrganoSearch'];

    function OrganoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Organo, OrganoRelevante, OrganoSearch) {
        var vm = this;

        vm.organo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.organorelevantes = OrganoRelevante.query();
        vm.autocompleteOrgano = autocompleteOrgano;
        vm.responseOrganos = [];
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            console.log(vm.organo)
            vm.isSaving = true;
            if (vm.organo.id !== null) {
                Organo.update(vm.organo, onSaveSuccess, onSaveError);
            } else {
                Organo.save(vm.organo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:organoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        function autocompleteOrgano(input_query) {
            return OrganoSearch.query({
                query: formatInputQuery(input_query),
                page: 0,
                size: 100,
                sort: 'id,asc'
            }).$promise.then(function(data) {
                vm.responseOrganos = data;
                return data;
            }).catch(function() {
                console.error("error autocompleteOrgano");
                return $q.reject("error");
            });

        }
        function formatInputQuery(input_query) {
            var query = "";
            var aux_input = formatInput(input_query);
            if (aux_input != null) {
                query = "\"^" + aux_input + "\"$";
                if (query.indexOf(" ") < 0) {
                    query = query + " and " + aux_input + "*";
                }
            }
            return query;
        }

        function formatInput(input_query) {
            var output = "";
            if (input_query != null) {
                input_query.toUpperCase();
                output = input_query.replace("/", "?");
            }
            return output.trim();
        }
    }
})();
